import { connect } from 'react-redux'

import IntegrationActionContentJiraCloud from './view'

export { default as shouldShowAction } from './shouldShowAction'

export default connect(() => ({
  provider: 'jira_cloud',
}))(IntegrationActionContentJiraCloud)
